import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TabsService {
  tab: BehaviorSubject<string> = new BehaviorSubject<string>('decide');
  constructor() {}
}
